import { Toaster } from 'react-hot-toast';
import Theme from './Theme';
import Routes from './routes/routes';

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontSize: '12px',
            fontFamily: 'ui-monospaced',
          },
        }}
      />
      <Theme />
      <Routes />
    </>
  );
}

export default App;
